import React, { Component } from 'react';
import Stepper from 'react-stepper-horizontal';
import firebase from 'firebase'
import sincronizar from '../../img/sincronizar.png'
import dormir from '../../img/dormir.png'

class InfoViaje extends Component {
    constructor(props) {
        super(props);
        this.state={
            ruta:[],
            paradas:[],
            isSinc:false,
            viajeAsig:'',
        }
    }

    componentDidMount(){
        let { userViaj, userActu } = this.props;
        firebase.database().ref('Rutas/'+userViaj.ruta).once('value').then(snapR =>{
            let ruta = snapR.val();
            let paradas = [];
            paradas.push({ title: this.capitalize(this.getFirstWord(ruta.inicio.nombre, ','))})
            if(Array.isArray(ruta.paradas)){
                ruta.paradas.forEach(element => {
                    paradas.push({ title: element.referencia })
                });
            }
            paradas.push({ title: this.capitalize(this.getFirstWord(ruta.destino.nombre, ','))})
            this.setState({ruta,paradas})
        })
    }

    capitalize(s){
        let temp = s.split(" ");
        let res = "";
        for(let i = 0; i < temp.length; i++){
          res = res + " " + temp[i].charAt(0).toUpperCase() + temp[i].substr(1).toLowerCase();
        }
        return res;
    }

    getFirstWord(s, separator){
        let r = s.split(separator);
        return r[0];
    }


    render() {
        let { userActu, userVehi, userViaj, sincData } = this.props;
        let { paradas, ruta } = this.state;
        
        return (
            
            <div>
            <div className='yellowTop'>
                    <p className='titulos'>Bienvido</p>
                    <p className='titulos'>{userActu.nombre}</p>
                    <p className='subtitulos' >Conductor</p> 
                </div>
            <div style={{ width: '100%',  height: 'auto' }}>
                
                
                <div className='whiteBottom' style={{marginTop:'100px'}} >
                    <p className='titulosInf'>Vehículo asignado</p>
                    <p className='titulosInfSub'>{userVehi.movil}</p>

                    <p className='titulosInf'>Ruta asignada</p>
                    <p className='titulosInfSub'>{ruta.nombRuta}</p>

                    <p className='titulosInf'>Hora itinerada de salida  </p>
                    <p className='titulosInfSub'>{userViaj.horaInicio}</p>

                    <div className="col-12 col-md-12 hideO" style={{marginTop:'50px'}}>
                        <Stepper
                            circleFontColor='transparent'
                            defaultColor="#C0C0BC"
                            activeColor="#C0C0BC"
                            completeColor="#C0C0BC"
                            defaultTitleColor='#000'
                            size={14}
                            steps={paradas}/>
                    </div>
                    <div className='centerBtn'>
                        <div className='insider'>
                            {
                                <img onClick={sincData} className='imgC' src={sincronizar} alt="menu" />
                            }
                        </div>
                    </div>
                </div>
                <div>
                    <img className='imgC fixScreen3' src={userVehi.foto} alt="menu" />
                </div>
            </div>
            
            </div>
        )
    }
}
export default InfoViaje;


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/InfoViaje.js